<template>
  <div class="productTableCom">
    <v-data-table
      :headers="headersTmp"
      :items="items"
      :item-key="itemKey"
      :hide-default-header="false"
      :no-data-text="$t('common.common_not-register')"
      hide-default-footer
      :items-per-page="-1"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-if="!items.length">
            <td :colspan="headersTmp.length" class="text-center">
              {{ $t('sale.sale_not-product') }}
            </td>
          </tr>

          <tr v-for="(item, trIndex) in items" :key="`group-${trIndex}`">
            <template v-for="(header, index) in headersTmp">
              <td
                v-bind:class="{
                  tdStyleCenter: getAlign(header.value) === 'center',
                  tdStyleEnd: getAlign(header.value) === 'end',
                  DisplayNone: getAlign(header.value) === ' d-none'
                }"
                :key="index"
              >
                <!-- {{ header.value }} -->
                <slot :name="header.value" v-bind:item="item">
                  <div v-if="isName(header, 'isEnabled')">
                    {{ getProductStatus(item.isEnabled) }}
                  </div>
                  <div v-else-if="isName(header, 'isEnabledPenguin')">
                    {{ getProductEnabledPenguinName(item.isEnabledPenguin) }}
                  </div>
                  <div
                    v-else-if="isName(header, 'productInfo')"
                    class="font-weight-bold"
                  >
                    {{ item.nameJp }} <br />
                    <div v-if="item.nameCn">{{ item.nameCn }} <br /></div>
                  </div>
                  <!-- 商品カテゴリ -->
                  <div v-else-if="isName(header, 'categoryId')">
                    {{
                      getProductCategoryName(
                        item.categoryId,
                        getProductCategoryFromState()
                      )
                    }}
                  </div>
                  <div v-else-if="isName(header, 'taxId')">
                    {{ getTaxValue(getRowValue(item, header.value)) }}
                  </div>
                  <div v-else-if="isName(header, 'weight')">
                    <div v-if="item.weight">
                      {{ item.weight + 'g' }}
                    </div>
                    <div v-else>{{ '-' }}</div>
                  </div>
                  <div v-else-if="isName(header, 'url')">
                    <div v-if="item.url">
                      <a v-if="item.url.length < 10" :href="item.url"
                        >{{ item.url }}
                      </a>
                      <a v-else :href="item.url"
                        >{{ item.url.substring(0, 9) + '...' }}
                      </a>
                    </div>
                  </div>
                  <div v-else-if="isName(header, 'taxExcludedRetailPrice')">
                    <div v-if="item.taxExcludedRetailPrice">
                      {{
                        formatPrice(
                          Number(item.taxExcludedRetailPrice)
                        ).toLocaleString() +
                        getCurrencyUnitName(
                          item.taxExcludedRetailPriceCurrencyId
                        )
                      }}
                    </div>
                    <div v-else>{{ '-' }}</div>
                  </div>
                  <div v-else-if="isName(header, 'purchasePrice')">
                    <div v-if="item.purchasePrice">
                      {{
                        formatPrice(
                          Number(item.purchasePrice)
                        ).toLocaleString() +
                        getCurrencyUnitName(item.purchasePriceCurrencyId)
                      }}
                    </div>
                    <div v-else>{{ '-' }}</div>
                  </div>
                  <div v-else-if="isName(header, 'edit')">
                    <v-layout>
                      <WhiteButton
                        text="common.common_edit"
                        height="32px"
                        width="32px"
                        class="mx-1"
                        @click="edit(item)"
                      />
                      <div v-if="item.isEnabled" class="mx-auto">
                        <NormalButton
                          :text="$t('表示')"
                          btnClass="pa-2"
                          height="32px"
                          @click="editIsEnabledToFalse(item)"
                        />
                      </div>
                      <div v-else class="mx-auto">
                        <NormalButton
                          :text="$t('非表示')"
                          btnClass="pa-2"
                          height="32px"
                          color="white"
                          textColor="thinText--text"
                          @click="editIsEnabledToTrue(item)"
                        />
                      </div>
                    </v-layout>
                  </div>
                  <div v-else>
                    {{ getDefaultValue(item, header) }}
                  </div>
                </slot>
              </td>
            </template>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { currencyUtil, consumptionTaxUtil, commonUtil } from '@/util'
import { mapActions, mapGetters } from 'vuex'
import { NormalButton, WhiteButton } from '@/components/items'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'ProductTable',

  components: {
    WhiteButton,
    NormalButton
  },
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({})
    },
    headers: [],
    items: [],
    itemKey: String,
    search: { default: '' },
    productKey: String
  },
  data: () => ({
    itemsDetail: [],
    headersTmp: [],
    editProductData: {},
    productCategoryList: []
  }),
  created() {
    this.createHeaders()
    this.getProductCategoryList()
  },
  methods: {
    ...mapGetters('Common', [
      'getProductCategoryFromState',
      'getCurrencyListFromState'
    ]),
    ...mapActions('Product', ['editProduct']),
    async getProductCategoryList() {
      this.productCategoryList = this.getProductCategoryFromState()
    },

    createHeaders() {
      this.itemsDetail = this.headers.map((header) => {
        return {
          value: header.value,
          inputType: 'inputType' in header ? header.inputType : '',
          unit: 'unit' in header ? header.unit : '',
          currencyIdName:
            'currencyIdName' in header ? header.currencyIdName : '',
          align: 'align' in header ? header.align : ''
        }
      })
      this.headersTmp = this.headers.map((header) => {
        const tmp = { ...header }
        tmp.text = this.$t(tmp.text)
        delete tmp.inputType
        delete tmp.unit
        return tmp
      })
    },
    isName(header, name) {
      return header.value === name
    },
    getRowValue(obj, path) {
      let tmp = this.getValue(obj, path)
      return typeof tmp === 'undefined' ? '' : tmp
    },
    getValue(obj, path) {
      if (!path) return obj
      const properties = path.split('.')
      return this.getValue(obj[properties.shift()], properties.join('.'))
    },
    getCurrencyUnitName(currencyId) {
      const currencyInfo = this.getCurrencyListFromState().find(
        (ele) => ele.currencyId === currencyId
      )
      const currencyUnitName = currencyInfo ? currencyInfo.unitName : ''
      return currencyUnitName
    },
    getItemsDetailRecord(value) {
      return this.itemsDetail.find((header) => header.value === value)
    },
    getUnit(item, header) {
      const tmp = this.getItemsDetailRecord(header.value)
      if (!tmp.currencyIdName) return ''

      const currencyId = item[tmp.currencyIdName]
      return currencyUtil.findCurrencyNameById(currencyId).unitName
    },
    getAlign(value) {
      const tmp = this.getItemsDetailRecord(value)
      return tmp ? tmp.align : ''
    },
    getProductStatus(isEnable) {
      const productStatus = isEnable
        ? this.$t('common.common_normal')
        : this.$t('common.common_hide')
      return productStatus
    },
    getProductEnabledPenguinName(isEnabledPenguin) {
      const productEnabledPenguinName = isEnabledPenguin
        ? this.$t('product.product_link-with-penguin-status')
        : '-'
      return productEnabledPenguinName
    },
    getProductCategoryName(categoryId, productCategoryList) {
      for (let productCategory of productCategoryList) {
        if (productCategory.productCategoryId === categoryId) {
          return productCategory.name
        }
        if (productCategory.childProductCategoryList) {
          const productCategoryName = this.getProductCategoryName(
            categoryId,
            productCategory.childProductCategoryList
          )
          if (productCategoryName) {
            return productCategoryName
          }
        }
      }
      return null
    },
    getTaxValue(id) {
      return consumptionTaxUtil.getConsumptionTaxIdInfo(id)
    },
    getDefaultValue(item, header) {
      const val = this.getRowValue(item, header.value)
      return val ? val + this.getUnit(item, header) : '-'
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    },
    async edit(productData) {
      this.editProductData = await _cloneDeep(productData)
      this.$emit('edit', this.editProductData)
    },
    async editIsEnabledToFalse(productData) {
      const inputData = this.initDataForEditProduct(productData, false)
      await this.editProduct({
        productId: inputData.productId,
        params: inputData
      })
      productData.isEnabled = 0
      //this.$router.go({path: this.$router.currentRoute.path, force: true})
    },
    async editIsEnabledToTrue(productData) {
      const inputData = this.initDataForEditProduct(productData, true)
      await this.editProduct({
        productId: inputData.productId,
        params: inputData
      })
      productData.isEnabled = 1
      //this.$router.go({path: this.$router.currentRoute.path, force: true})
    },
    initDataForEditProduct(formatData, isEnabled) {
      const inputData = {
        productId: formatData.productId,
        productInfoLine1: {
          productNumber: formatData.productNumber,
          supplierId: { value: formatData.supplierId },
          categoryId: formatData.categoryId,
          productNameJp: formatData.nameJp,
          productNameCn: formatData.nameCn,
          taxExcludedRetailPrice: formatData.taxExcludedRetailPrice,
          taxExcludedRetailPriceCurrency: {
            value: formatData.taxExcludedRetailPriceCurrencyId
              ? formatData.taxExcludedRetailPriceCurrencyId
              : this.getCurrencyJpFromState().value
          },
          purchasePrice: formatData.purchasePrice,
          purchasePriceCurrency: {
            value: formatData.purchasePriceCurrencyId
              ? formatData.purchasePriceCurrencyId
              : this.getCurrencyJpFromState().value
          },
          //消費税の初期値10%  "consumptionTaxId": 2,"taxRate": "10%"
          taxId: formatData.taxId ? formatData.taxId : 2
        },
        productInfoLine2: {
          gtinCode: formatData.gtinCode,
          janCode: formatData.janCode,
          lotQuantity: formatData.lotQuantity,
          capacity: formatData.capacity,
          weight: formatData.weight,
          url: formatData.url,
          alertPeriod: formatData.alertPeriod,
          isEnabled: isEnabled ? 1 : 0,
          isEnabledPenguin: formatData.isEnabledPenguin
        },
        productDetailInfoLine1: {
          productImg: formatData.productImg,
          makerName: formatData.makerName,
          brandName: formatData.brandName,
          productWidth: formatData.productWidth,
          productHeight: formatData.productHeight,
          productDepth: formatData.productDepth,
          packageWidth: formatData.packageWidth,
          packageHeight: formatData.packageHeight,
          packageDepth: formatData.packageDepth,
          packageWeight: formatData.packageWeight,
          cartonQuantity: formatData.cartonQuantity,
          titleCopyJp: formatData.titleCopyJp,
          titleCopyCn: formatData.titleCopyCn
        },
        productDetailInfoLine2: {
          catchCopyJp: formatData.catchCopyJp,
          catchCopyCn: formatData.catchCopyCn,
          bodyCopyJp: formatData.bodyCopyJp,
          bodyCopyCn: formatData.bodyCopyCn,
          approvalAcquisition: formatData.approvalAcquisition,
          component: formatData.component
        }
      }
      return inputData
    }
  }
}
</script>
<style lang="scss" scoped>
.productTableCom {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1) !important;
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    background-color: #fafafb;
    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 0;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;
    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table td:last-child {
    border-right: 0;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
    border-collapse: collapse;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td:last-child {
    border-right: 0;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }

  .tdStyleCenter {
    text-align: center !important;
    padding: 10px 0;
  }
  .tdStyleEnd {
    text-align: right !important;
  }
  .DisplayNone {
    display: none;
  }
  .exportSubjectFlg {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
